export default __webpack_public_path__ + "src/images/packages/emily-moon-lodge/247f01fa5cb99b698b94527c95e2020d-2.jpg";